import { render, staticRenderFns } from "./viewingDisciplineVebinars.vue?vue&type=template&id=379af7c1"
import script from "./viewingDisciplineVebinars.vue?vue&type=script&lang=js"
export * from "./viewingDisciplineVebinars.vue?vue&type=script&lang=js"
import style0 from "./viewingDisciplineVebinars.vue?vue&type=style&index=0&id=379af7c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports